<template>
  <div
    :id="group.categoryId"
    class="shopItemGroup"
    :class="{isHiddenGroup: group.isHiddenGroup}"
    :style="groupMargin">
    <div v-if="!settings.hiddenCategoryGroup" class="shopPathName">
      <span
        v-for="(name, index) in groupName"
        :key="index"
        class="name">
        {{ name[lang] }}
      </span>
    </div>

    <p v-if="categoryItemLimit" class="categoryLimitMessage">
      {{ categoryLimitMessage(groupName[groupName.length - 1][lang], categoryItemLimit.max) }}
      <span v-if="categoryItemLimit.countByOrder && categoryItemLimit.billingCount">({{ categoryBillingMessage(categoryItemLimit.billingCount) }})</span>
    </p>

    <div class="shopItems"
      :style="gridStyle">
      <Item
        v-for="(item, index) in group.items"
        :key="index"
        :locale="locale"
        :lang="lang"
        :item="item"
        :shopPageId="shopPageId"
        :settings="settings"
        :itemCategory="group.categoryId"
        :categoryItemLimit="categoryItemLimit"
        class="shopItem"
        @addCart="addCart"
        @setToastMessage="setToastMessage" />
    </div>
  </div>
</template>

<script>
import Item from './Item'

export default {
  name: 'ShopItemGroup',
  props: [
    'locale',
    'lang',
    'group',
    'shopPageId'
  ],
  components: {
    Item
  },
  computed: {
    groupName () {
      return this.group && this.group.itemGroupName
    },
    settings () {
      return this.$store.getters['shop/getShopSettings'](this.shopPageId)
    },
    gridStyle () {
      const settings = this.settings
      const marginTb = (parseInt(settings.itemMarginTb) - 1) * 0.4 + 1.2
      const marginlr = (parseInt(settings.itemMarginLr) - 2) * 0.4 + 1
      const tb = settings && settings.itemMarginTb ? marginTb : 4
      const lr = settings && settings.itemMarginLr ? marginlr : 3
      return {
        gridRowGap: `${tb}em`, // 4(1.8em)
        gridColumnGap: `${lr}em` // 3(1.4em)
      }
    },
    groupMargin () {
      const settings = this.settings
      const marginTb = (parseInt(settings.itemMarginTb) - 1) * 0.4 + 1.2
      const tb = settings && settings.itemMarginTb ? marginTb : 4
      return {
        paddingTop: `${tb}em`
      }
    },
    isHiddenGroup () {
      return this.group.isHiddenGroup
    },
    categoryItemLimit () {
      const catCode = this.$store.getters['shop/getShopCatCode'](this.shopPageId)
      const categoryId = this.group && this.group.categoryId
      const limitCount = categoryId && this.$store.getters['shop/getCategoryLimitCount'](this.shopPageId, catCode, categoryId)
      return limitCount
    }
  },
  watch: {
    isHiddenGroup (isHiddenGroup) {
      const getHiddenGroup = this.$store.getters['shop/getHiddenGroup'] || []
      const categoryId = this.group.categoryId
      this.$store.commit('shop/setHiddenGroupIds', { categoryId: categoryId, isHidden: isHiddenGroup })
      // if (isHiddenGroup && !getHiddenGroup.includes(getHiddenGroup)) {
      //   this.$store.commit('shop/setHiddenGroupIds', { categoryId: categoryId, isHidden: true })
      // } else if (!isHiddenGroup && getHiddenGroup.includes(getHiddenGroup)) {
      //   this.$store.commit('shop/setHiddenGroupIds', { categoryId: categoryId, isHidden: false })
      // }
    }
  },
  methods: {
    categoryLimitMessage (categoryName, limit) {
      const messageLimit = this.locale.category_item_count_limit.replace('{categoryName}', categoryName).replace('{var}', limit)
      return messageLimit
    },
    categoryBillingMessage (current) {
      const messageOrder = this.locale.category_item_count_order.replace('{var}', current)
      return messageOrder
    },
    addCart (data) {
      this.$emit('addCart', data)
    },
    setToastMessage (message, dur) {
      this.$emit('setToastMessage', message, dur)
    },
  }
}
</script>
